import { Box, Flex, useColorModeValue } from "@chakra-ui/react";

import { IChildrenProp } from "types/IChildrenProp";

import { useGetThemeColors } from "ChakraTheme";
import { Footer, Header } from "components/LayoutComponents";

interface IProps extends IChildrenProp {}

const Layout = ({ children }: IProps) => {
  const colors = useGetThemeColors();
  const mainBackgroundColor = useColorModeValue("#eeeeee", colors.gray[700]);

  return (
    <>
      <Box backgroundColor={mainBackgroundColor} flex="1 0 auto">
        <Header />
        <Flex
          mt={{ base: "100px", lg: "80px" }}
          direction={{
            base: "column",
            lg: "row",
          }}
          mb={6}
          position="relative"
          zIndex="1"
        >
          {children}
        </Flex>
      </Box>
      <Footer />
    </>
  );
};

export { Layout };
